import React from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { Link } from 'react-router-dom'
import { Group, TransferWithinAStation, WorkHistory } from '@mui/icons-material'
import BusinessHourSetup from '../../schedule/components/BusinessHourSetup'

function AssociateLandingPage() {
    const reload = () =>{

    }
    return (
    <AppLayout>
        <div className='container'>
            <BusinessHourSetup callBack={reload} />
            <div className='row mt-5 text-center'>
                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/schedule/business-hours"} className='btn text-white'   >
                            <h3><WorkHistory style={{fontSize:60}} /></h3>
                            <p>Business Hours</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/client/dashboard"} className='btn text-white'   >
                            <h3><Group style={{fontSize:60}} /></h3>
                            <p>Clients</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
    )
}

export default AssociateLandingPage